<template>
  <div v-if="data" class="incomplete-data" :class="`incomplete-data--${variant}`">
    <Tooltip placement="top">
      <template #trigger> <i class="incomplete-data__icon base-icon">info</i> </template>
      <div>
        <div class="incomplete-data__title">Niepełne dane:</div>
        <div class="incomplete-data__info">{{ data }}</div>
      </div>
    </Tooltip>
  </div>
</template>

<script lang="ts" setup>
  import { Tooltip } from '@/components/ui'

  defineProps<{
    data: string
    variant: 'day' | 'week'
  }>()
</script>

<style scoped lang="scss">
  .incomplete-data {
    &__icon {
      display: block;
      width: 19px;
      line-height: 16px;
      color: var(--color-tertiary-text);
      cursor: pointer;
    }

    &--day .incomplete-data__icon {
      font-size: 18px;
    }

    &--week .incomplete-data__icon {
      height: 16px;
      font-size: 20px;
    }

    &__title {
      margin-bottom: 8px;
      font-family: Montserrat-Medium;
      text-align: center;
    }

    &__info {
      white-space: pre;
    }
  }
</style>
